module.exports = __webpack_public_path__ + "static/MOD3-9c80ba3657fc018a04fc250bc79dcc31.jpg";